import { forwardRef } from 'react';
import styled from '@emotion/styled';
import * as tokens from '@tokens';
import type { BasePopoverContainerProps } from './BasePopoverContainer';
import { BasePopoverContainer } from './BasePopoverContainer';

export type PopoverContainerProps = BasePopoverContainerProps;

const StyledBasePopoverContainer = styled(BasePopoverContainer)`
  padding: ${tokens.spacer.x2};
`;

/**
 * PopoverContainer component
 *
 * **WARNING!** _This component is for internal use in the Design System. If you
 * need to use it for a custom component, please discuss your use case with
 * the Design System squad before proceeding, as they may be able to help
 * you with a better solution._
 *
 * @summary Provides a low-level implementation for the Popover component.
 * @see Popover
 */
export const PopoverContainer = forwardRef<HTMLElement, PopoverContainerProps>(
  (
    { children, ...basePopoverContainerProps }: PopoverContainerProps,
    ref,
  ): JSX.Element => {
    return (
      <StyledBasePopoverContainer ref={ref} {...basePopoverContainerProps}>
        {children}
      </StyledBasePopoverContainer>
    );
  },
);

PopoverContainer.displayName = 'PopoverContainer';
